// extracted by mini-css-extract-plugin
module.exports = {"group":"UserGroup_group__108fb","icon":"UserGroup_icon__33HpO"};